export default function PHP_join() {
  return (
    <div>
      <h1>PHP_join</h1>
    </div>
  );
}
